let jobIndexFunctions = (function () {
  let modules = {};
  modules.LIKE = "like";

  modules.UNLIKE = "unlike";

  modules.likeUnlikeJob = function (button, jobId, isUnLike = true) {
    modules.syncLikeStatus(jobId, isUnLike);
    let url = isUnLike
      ? Routes.destroy_favorite_jobs_path()
      : Routes.create_favorite_jobs_path();
    let submitAjax = $.ajax({
      url: url,
      method: "POST",
      data: {
        authenticity_token: $("meta[name=csrf-token]").prop("content"),
        job_id: jobId,
      },
    });
    submitAjax.done(function (response) {
      if (!response.save) {
        commonFunctions.notifyToastr(button, commonFunctions.TOASTR_ERROR);
      }
      button.prop("disabled", false);
      modules.syncLikeStatus(jobId, isUnLike);
    });
    submitAjax.fail(function (response) {
      commonFunctions.notifyToastr(button, commonFunctions.TOASTR_ERROR);
      modules.syncLikeStatus(jobId, !isUnLike);
      button.prop("disabled", false);
    });
  };

  modules.syncLikeStatus = function (job_id, isUnLike = true) {
    if (isUnLike) {
      $(".btn-like-job[data-id=" + job_id + "]").removeClass("has-favorited");
    } else {
      $(".btn-like-job[data-id=" + job_id + "]").addClass("has-favorited");
    }
  };

  return modules;
})(window.jQuery, window, document);

var stickyEl = $("#sticky-widget");
if (stickyEl && stickyEl.offset()) {
  var offsetTop = stickyEl.offset().top;
  window.onscroll = function () {
    if (window.pageYOffset + 80 >= offsetTop) {
      stickyEl.addClass("sticky");
      $(".main-content--right").css("padding-left", 0);
    } else {
      stickyEl.removeClass("sticky");
      $(".main-content--right").css("padding-left", "40px");
    }
  };
}

$(".main-content--right").on("click", "#btn-close-jd", function () {
  $(".job-card").removeClass("active");
  $(".content-right__job-detail").addClass("d-none").empty();
  $(".content-right__side-job").removeClass("d-none");
});

$(window).on("scroll", function () {
  if ($(".main-content--right").length > 0) {
    var x =
      $(window).scrollTop() +
      $(window).height() -
      $(".main-content--right").offset().top -
      $(".main-content--right").innerHeight();
    if (x > 0) {
      $("#sticky-widget").css({
        bottom: x,
        top: -x,
      });
    } else {
      $("#sticky-widget").css({
        bottom: "20px",
        top: "100px",
      });
    }
  }
});

function makeTag(modal_name, tag_id, tag_text) {
  var clone_tag = $(modal_name)
    .find("#clone-tag.d-none .tag-item:first")
    .clone();
  clone_tag.attr({
    id: tag_id,
  });
  clone_tag.find("span.tag-item__name").text(tag_text);
  return clone_tag;
}

function addTag(modal_name, tag) {
  $(modal_name).find("#tag-selected-area").append(tag);
}

function removeTag(modal_name, tag_id) {
  $(modal_name).find(`#tag-selected-area #${tag_id}`).remove();
}

function changeCheckBox(modal_name, checkbox_id, is_check) {
  $(modal_name)
    .find("input#" + checkbox_id)
    .prop("checked", is_check);
}

function clearAllCondition(modal_name) {
  $(modal_name).find('input[type="checkbox"]').prop("checked", false);
  $(modal_name).find('input[type="radio"]').prop("checked", false);
  $(modal_name).find("#tag-selected-area").empty();
}

function getSearchConditions() {
  let inputs = $(".modal-search").find('input[type="checkbox"]:checked');
  let data = {};
  let salary = $(".modal-search").find('input[type="radio"]:checked').val();
  if (salary) {
    data["salary"] = salary;
  }
  $.each(inputs, function (_, input) {
    if (data[input.dataset.modal]) {
      data[input.dataset.modal] += "," + input.value;
    } else {
      data[input.dataset.modal] = input.value;
    }
  });
  return data;
}

function convertUrl2Params() {
  var query = decodeURIComponent(location.search).substring(1).split("&");
  return query.reduce(function (acc, cur) {
    if (cur) {
      var search = cur.split("=");
      var param_key = search[0];
      var value = search[1];
      acc[param_key] = value;
    }
    return acc;
  }, {});
}

function reInitModal(modal_name, field, value) {
  clearAllCondition(modal_name);
  if (value && value.split(",")) {
    $.each(value.split(","), function (_, id) {
      var checkbox_id = `${field}_${id}`;
      if($(`#${checkbox_id}`).length > 0) {
        var tag_text = $(`#${checkbox_id}`).parent().text();
        var tag_id = `${field}_tag_${id}`;
        addTag(modal_name, makeTag(modal_name, tag_id, tag_text));
        changeCheckBox(modal_name, checkbox_id, true);
      }
    });
  }
}
function reCountJob() {
  let data = getSearchConditions();
  let keyword = $.trim($("#job_search_form_keyword").val());
  let url = decodeURIComponent(Routes.count_jobs_path(data));
  if (keyword.length != 0) {
    url = [Routes.count_jobs_path({keyword: keyword}), url.split("?")[1]].join("&");
  }
  $.ajax({
    type: "GET",
    url: url,
    dataType: "json"
  })
    .done(function (response) {
      $(".modal-search.show .js-job-count").text(response["job_count"]);
    })
    .fail(function (errorThrown) {});
}

let list_model = [
  "skill",
  "occupation",
  "salary",
  "industry",
  "area",
  "work_style",
  "tag",
];
let params = convertUrl2Params();
$.each(list_model, function (_, model) {
  let regex_pathname = new RegExp("\\/jobs\\/" + model + "-(\\d)+", "g");
  let lps = location.pathname.match(regex_pathname);
  lps && (params[model] = lps[0].match(/(\d)+/g)[0]);
});
$.each(list_model, function (_, model) {
  let modal_name = "#modal-" + model;
  let field = "job_search_form_" + model;
  let modalEl = document.getElementById(`modal-${model}`);
  if (modalEl) {
    modalEl.addEventListener("hidden.bs.modal", function () {
      reInitModal(modal_name, field, params[model]);
    });
    modalEl.addEventListener("shown.bs.modal", function () {
      reCountJob();
    });
  }

  $(modal_name)
    .find('input[type="checkbox"]')
    .on("change", function (e) {
      var checked = this.checked;
      var reg = new RegExp("^" + field + "_\\d+$", "g");
      if (e.target.id.match(reg)) {
        var tag_id = `${field}_tag_${e.target.id.match(/\d+/g)[0]}`;
        if (checked) {
          var tag_text = $(this).parent().text();
          addTag(modal_name, makeTag(modal_name, tag_id, tag_text));
        } else {
          removeTag(modal_name, tag_id);
        }
      }
      reCountJob();
    });
  if (model === "salary") {
    $(modal_name)
      .find('input[type="radio"]')
      .on("change", function () {
        reCountJob();
      });
  }
  $(modal_name)
    .find("#tag-selected-area")
    .on("click", "button.tag-item__button-delete", function (e) {
      if (e.target.parentElement.id.match(/\d+/g)) {
        var id = e.target.parentElement.id.match(/\d+/g)[0];
        var checkbox_id = `${field}_${id}`;
        var tag_id = `${field}_tag_${id}`;
        changeCheckBox(modal_name, checkbox_id, false);
        removeTag(modal_name, tag_id);
        reCountJob();
      }
    });
  $(modal_name)
    .find("#btn-condition-clear")
    .on("click", function () {
      clearAllCondition(modal_name);
      reCountJob();
    });
});

$(".job-list-container, .job-list-container-sp").on(
  "click",
  ".btn-like-job",
  function () {
    $(this).prop("disabled", true);
    jobIndexFunctions.likeUnlikeJob(
      $(this),
      $(this).data("id"),
      $(this).hasClass("has-favorited")
    );
  }
);

$("body").on("click", ".js-show-detail", function (e) {
  if ($("#check_user_signed_in").val() == 'false') {
    let id_job = $(this).attr("data-id");
    if (localStorage.getItem("read_jobs")) {
      let read_jobs = JSON.parse(localStorage.getItem("read_jobs"));
      read_jobs.push(id_job);
      localStorage.setItem("read_jobs", JSON.stringify(read_jobs));
    } else {
      let read_jobs = [id_job];
      localStorage.setItem("read_jobs", JSON.stringify(read_jobs));
    }
  }
  if ($(e.target).is(".btn-like-job") || $(this).hasClass("active")) {
    return;
  }
  $(".job-card").removeClass("active");
  $(this).addClass("active");
  $(".content-right__job-detail").removeClass("d-none");
  $(".content-right__side-job").addClass("d-none");
  let job_id = $(this).data("id");
  $.ajax({
    method: "GET",
    url: Routes.job_path({ id: job_id }),
    dataType: "text",
    data: {
      is_show_detail: true
    }
  })
    .done(function (response) {
      if ($("#check_user_signed_in").val() == 'false') {
        $(".js-show-detail.active .tags .job-label-soft-peach").removeClass("d-none");
      } else {
        if ($(".js-show-detail.active .tags .job-label-soft-peach").hasClass("d-none")) {
          $(".js-show-detail.active .tags .job-label-soft-peach").removeClass("d-none");
        }
      }
      $(".js-show-detail.active .tags .job-label-orange").remove();
      $(".js-job-detail").attr("data-id", job_id).html(response);
    })
    .fail(function (errorThrown) {});
});

$(".job-list-container-sp").on("click", ".job-card-sp a", function (e) {
  e.preventDefault();
  if ($(e.target).is(".btn-like-job")) {
    return;
  }
  var url = $(this).attr("href");
  Turbolinks.visit(url);
});

$(".js-submit-filter-btn").on("click", function () {
  let data = getSearchConditions();
  let keyword = $.trim($("#job_search_form_keyword").val());
  let url = decodeURIComponent(Routes.jobs_path(data));
  if (keyword.length != 0) {
    if (url.split("?").length > 1) {
      url = [Routes.jobs_path({keyword: keyword}), url.split("?")[1]].join("&");
    } else {
      url = Routes.jobs_path({keyword: keyword});
    }
  }
  window.location.href = url;
});

$("#job_search_form_keyword").on("keypress", function (event) {
  if (event.key === "Enter") {
    event.preventDefault();
    $(".js-submit-filter-btn").click();
  }
})

$(".js-job-sort").on("change", function () {
  let url = new URL(window.location.href);
  url.searchParams.set("sort", this.value);
  window.location.href = url.href;
});

$(".js-job-per_page").on("change", function () {
  let url = new URL(window.location.href);
  url.searchParams.set("per_page", this.value);
  url.searchParams.delete("page");
  window.location.href = url.href;
});

$(".js-job-change-page").on("click", function () {
  let url = new URL(window.location.href);
  let page = Math.max(this.parentElement.firstChild.value, 1);
  page = Math.min(page, this.parentElement.firstChild.max);
  url.searchParams.set("page", page);
  window.location.href = url.href;
});

$(".js-job-previous-page").on("click", function (e) {
  if ($(this).hasClass("disabled")) {
    return false;
  }
  let url = new URL(window.location.href);
  let currentPage = parseInt(url.searchParams.get("page"));
  if (currentPage > 1) {
    url.searchParams.set("page", currentPage - 1);
    window.location.href = url.href;
  }
});

$(".js-job-next-page").on("click", function (e) {
  if ($(this).hasClass("disabled")) {
    return false;
  }
  let url = new URL(window.location.href);
  let currentPage = parseInt(url.searchParams.get("page") || "1");
  if (currentPage < parseInt(this.dataset.total)) {
    url.searchParams.set("page", (currentPage || 1) + 1);
    window.location.href = url.href;
  }
});

$(document).ready(function() {
  if ($("#check_user_signed_in").val() == 'false') {
    let read_jobs = JSON.parse(localStorage.getItem("read_jobs"));
    $.each(read_jobs, function (key, value) {
      $(`.js-show-detail[data-id= ${value}] .tags .job-label-soft-peach`).removeClass("d-none");
    });
    var queryString = window.location.search;
    if (queryString == "") {
      var queryString = window.location.href;
      var params = [];
      var value_params = queryString.substring(queryString.indexOf("jobs") + "jobs".length).replace("-", "=");
      var value_params = value_params.substring(1);
      params.push(value_params);
    } else {
      queryString = queryString.substring(1);
      var params = queryString.split("&");
    }
    paramObject = {};
    for (var i = 0; i < params.length; i++) {
      var pair = params[i].split("=");
  
      paramObject[pair[0]] = decodeURIComponent(pair[1]);
    }
    if (localStorage.getItem('search_histories')){
      search_histories = JSON.parse(localStorage.getItem('search_histories'));
    } else {
      search_histories = [];
    }
    check_uniq_value_title = false;

    $.each(search_histories, function( index, value ) {
      sortedObj1 = {};
      Object.keys(paramObject).sort().forEach(function(key) {
        sortedObj1[key] = paramObject[key];
      });
      sortedObj2 = {};
      Object.keys(value["search_params"]).sort().forEach(function(key) {
        sortedObj2[key] = value["search_params"][key];
      });
      if (JSON.stringify(sortedObj1) == JSON.stringify(sortedObj2)) {
        check_uniq_value_title = true;
      }
    });
    if(check_uniq_value_title == false ){
      if ($("#job_search_form_keyword").val() == '' && paramObject[""] == "undefined") {
        return;
      }
      var attr_search = {
        id: Object.keys(search_histories).length + 1,
        title: $("#job_search_form_keyword").val(),
        search_params: paramObject
      }
      search_histories.push(attr_search);
      localStorage.setItem('search_histories', JSON.stringify(search_histories.slice(-10)));
    };
  };
});
$(document).on('click','.toggle-icon-top-pc', function(e){
  $(".condition_content_top_pc").toggle();
  $(".condition_item_top_pc .toggle-icon-plus-pc").toggleClass("d-none")
});
$(document).on('click','.toggle-icon-bottom-pc', function(e){
  $(".condition_content_bottom").toggle();
  $(".condition_item_bottom .toggle-icon-plus-pc").toggleClass("d-none")
});